export default __webpack_public_path__ + "static/ansible_tower-b02334a4e484c57ba577677baa1e27ad.png";